/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class CampaignsService {
    /**
     * Return active campaign names
     * @returns string Active campaign names
     * @throws ApiError
     */
    public static getActiveCampaigns({
        creatorId,
    }: {
        /**
         * Id of the creator task
         */
        creatorId: number,
    }): CancelablePromise<Array<string>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/dashboard/api/v1/campaigns/{creatorId}',
            path: {
                'creatorId': creatorId,
            },
            errors: {
                401: `Unauthorized`,
                403: `The user is missing any permission`,
            },
        });
    }
}
